import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

/**
 * Login gate (copied from the volto-polyglot precedent, DR-2026-261).
 *
 * wantai is private-by-default (DR-2026-258): content lives in the private
 * workflow state and anonymous requests are gated to a login. The deck route
 * (/en/deck) is an addonRoute — it renders regardless of nick content
 * permissions — so it must reproduce that posture itself. Reads the session
 * truth (state.userSession.token); when absent, redirect to /login with a
 * return_url so the user lands back on the deck after authenticating.
 */
const RequireLogin = ({ children }) => {
  const token = useSelector((state) => state.userSession?.token);
  const location = useLocation();

  if (!token) {
    return (
      <Redirect
        to={`/login?return_url=${encodeURIComponent(location.pathname)}`}
      />
    );
  }

  return <>{children}</>;
};

export default RequireLogin;
